import React, { Component } from "react";
import { injectIntl, IntlShape } from "@ai360/core/intl";

import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";
import { messages } from "../i18n-messages";

interface IGeneLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class GeneLog_ extends Component<IGeneLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
                records={this.getFormattedRecords(this.props.records)}
            />
        );
    }
}
export const GeneLog = injectIntl(withCrud(GeneLog_, service, actions));
